import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCar, FaSearch, FaPlus, FaEdit, FaTrash, FaEye, FaExchangeAlt, FaUndo, FaFilePdf, FaMapMarkerAlt } from 'react-icons/fa';
import axios from 'axios';

const Laanebiler = () => {
  const navigate = useNavigate();
  const isAdmin = (() => {
    try { return localStorage.getItem('userRole') === 'admin'; } catch (_) { return false; }
  })();
  const [laanebiler, setLaanebiler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [editingLaanebil, setEditingLaanebil] = useState(null);
  const [selectedLaanebil, setSelectedLaanebil] = useState(null);
  const [stationer, setStationer] = useState([]);
  const [workshopCars, setWorkshopCars] = useState([]);
  const [formData, setFormData] = useState({
    internt_nummer: '',
    vogn_type: '',
    erstatter_bil_id: '',
    status: 'Tilgængelig'
  });
  // Tilføj lånebil (promote) søgestate
  const [createQuery, setCreateQuery] = useState('');
  const [createLoading, setCreateLoading] = useState(false);
  const [createError, setCreateError] = useState('');
  const [createResults, setCreateResults] = useState([]);
  const [moveData, setMoveData] = useState({
    car_id: '',
    station_id: '',
    workshop_car_id: '',
    bemaerkninger: ''
  });
  const [users, setUsers] = useState([]);
  const [selectedRecipients, setSelectedRecipients] = useState([]);
  const [manualEmails, setManualEmails] = useState('');
  const [selectedUserId, setSelectedUserId] = useState('');

  useEffect(() => {
    fetchLaanebiler();
    fetchStationer();
    fetchUsers();
  }, []);

  const fetchLaanebiler = async () => {
    try {
      const response = await axios.get('/api/laanebiler');
      setLaanebiler(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching laanebiler:', error);
      setLoading(false);
    }
  };

  const fetchStationer = async () => {
    try {
      const response = await axios.get('/api/stationer');
      setStationer(response.data);
    } catch (error) {
      console.error('Error fetching stationer:', error);
    }
  };

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get('/api/indstillinger/brugere', {
        headers: token ? { Authorization: `Bearer ${token}` } : {}
      });
      setUsers(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      console.error('Error fetching brugere:', e);
      setUsers([]);
    }
  };

  const fetchWorkshopCars = async (stationId) => {
    if (!stationId) {
      setWorkshopCars([]);
      return;
    }
    try {
      const response = await axios.get(`/api/laanebiler/station/${stationId}/cars`);
      setWorkshopCars(response.data);
    } catch (error) {
      console.error('Error fetching workshop cars:', error);
      setWorkshopCars([]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingLaanebil) {
        await axios.put(`/api/laanebiler/${editingLaanebil.id}`, formData);
      } else {
        await axios.post('/api/laanebiler', formData);
      }
      setShowModal(false);
      setEditingLaanebil(null);
      setFormData({
        internt_nummer: '',
        vogn_type: '',
        erstatter_bil_id: '',
        status: 'Tilgængelig'
      });
      fetchLaanebiler();
    } catch (error) {
      console.error('Error saving laanebil:', error);
    }
  };

  const handleMove = async (e) => {
    e.preventDefault();
    try {
      // Åbn i nyt vindue som PHP versionen
      const formData = new FormData();
      formData.append('car_id', moveData.car_id);
      formData.append('station_id', moveData.station_id);
      formData.append('workshop_car_id', moveData.workshop_car_id);
      formData.append('bemaerkninger', moveData.bemaerkninger);
      if (selectedRecipients.length > 0) {
        selectedRecipients.forEach((id) => formData.append('recipients', id));
      }

      // Opret en skjult form og submit til nyt vindue
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/api/laanebiler/move';
      form.target = '_blank';

      Object.keys(moveData).forEach(key => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = moveData[key];
        form.appendChild(input);
      });

      // Tilføj valgte modtagere (kan være flere)
      if (selectedRecipients.length > 0) {
        selectedRecipients.forEach((id) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'recipients';
          input.value = id;
          form.appendChild(input);
        });
      }

      // Tilføj manuelle emails (kommasepareret)
      if (manualEmails && manualEmails.trim().length > 0) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'emails';
        input.value = manualEmails;
        form.appendChild(input);
      }

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);

      setShowMoveModal(false);
      setSelectedLaanebil(null);
      setMoveData({ car_id: '', station_id: '', workshop_car_id: '', bemaerkninger: '' });
      
      // Genindlæs siden efter 1 sekund som PHP versionen
      setTimeout(() => {
        fetchLaanebiler();
      }, 1000);
    } catch (error) {
      console.error('Error moving laanebil:', error);
    }
  };

  const handleReturn = async () => {
    try {
      // Åbn i nyt vindue som PHP versionen
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/api/laanebiler/return';
      form.target = '_blank';

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'car_id';
      input.value = selectedLaanebil.id;
      form.appendChild(input);

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);

      setShowReturnModal(false);
      setSelectedLaanebil(null);
      
      // Genindlæs siden efter 1 sekund
      setTimeout(() => {
        fetchLaanebiler();
      }, 1000);
    } catch (error) {
      console.error('Error returning laanebil:', error);
    }
  };

  const handleEdit = (laanebil) => {
    setEditingLaanebil(laanebil);
    setFormData({
      internt_nummer: laanebil.internt_nummer || '',
      vogn_type: laanebil.vogn_type || '',
      erstatter_bil_id: laanebil.erstatter_bil_id || '',
      status: laanebil.status || 'Tilgængelig'
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Er du sikker på, at du vil slette denne lånebil?')) {
      try {
        await axios.delete(`/api/laanebiler/${id}`);
        fetchLaanebiler();
      } catch (error) {
        console.error('Error deleting laanebil:', error);
      }
    }
  };

  const handleMoveClick = () => {
    setShowMoveModal(true);
  };

  const handleReturnClick = (laanebil) => {
    setSelectedLaanebil(laanebil);
    setShowReturnModal(true);
  };

  const generatePDF = async (laanebil) => {
    try {
      const response = await axios.get(`/api/laanebiler/${laanebil.id}/pdf`);
      const { html, data } = response.data;
      
      // Opret et nyt vindue med PDF indhold
      const newWindow = window.open('', '_blank');
      newWindow.document.write(html);
      newWindow.document.close();
      newWindow.print();
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  const filteredLaanebiler = laanebiler.filter(laanebil =>
    laanebil.internt_nummer?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    laanebil.vogn_type?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    laanebil.station_navn?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    laanebil.status?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-falck-blue"></div>
      </div>
    );
  }

  return (
    <div className="px-2 sm:px-4 md:px-6 py-2 sm:py-4">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Lånebiler</h1>
        <div className="flex gap-2">
          <button
            onClick={handleMoveClick}
            className="bg-falck-blue text-white px-3 py-2 text-sm sm:text-base sm:px-4 rounded-lg flex items-center gap-2 hover:bg-blue-700 transition-colors"
          >
            <FaExchangeAlt /> Flyt Lånebil
          </button>
          {isAdmin && (
            <button
              onClick={() => setShowModal(true)}
              className="bg-green-600 text-white px-3 py-2 text-sm sm:text-base sm:px-4 rounded-lg flex items-center gap-2 hover:bg-green-700 transition-colors"
            >
              <FaPlus /> Tilføj lånebil
            </button>
          )}
        </div>
      </div>

      {/* Søgefelt */}
      <div className="mb-6">
        <div className="relative">
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Søg efter lånebiler..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-700 rounded-lg focus:ring-2 focus:ring-falck-blue focus:border-transparent bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100"
          />
        </div>
      </div>

      {/* Lånebiler tabel */}
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-lg shadow overflow-hidden">
        <div className="scroll-fade-x"><div className="scroll-area">
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-gray-900 dark:text-white">
          <thead className="bg-gray-50 dark:bg-gray-800">
            <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Vogn nr.
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Vogn type
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Nummerplade
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Station
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Erstatter
              </th>
              {isAdmin && (
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  Handlinger
                </th>
              )}
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
            {filteredLaanebiler.map((laanebil) => (
              <tr key={laanebil.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => navigate(`/biler/profil/${laanebil.id}`)}>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {laanebil.internt_nummer}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {laanebil.vogn_type || '-'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {laanebil.nummerplade || '-'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                    laanebil.status === 'Udlånt' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200' :
                    laanebil.status === 'Tilgængelig' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' :
                    laanebil.status === 'Reserve' ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200' :
                    'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200'
                  }`}>
                    {laanebil.status}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {laanebil.erstattet_bil_station || 'Ikke udlånt'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {laanebil.erstattet_bil_internt_nummer || 'Ingen'}
                </td>
                {isAdmin && (
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" onClick={(e) => e.stopPropagation()}>
                    <div className="flex justify-end gap-2">
                      {laanebil.status === 'Udlånt' && (
                        <button
                          onClick={() => handleReturnClick(laanebil)}
                          className="text-red-600 hover:text-red-900"
                          title="Returner lånebil"
                        >
                          Returner
                        </button>
                      )}
                      <button
                        onClick={() => handleEdit(laanebil)}
                        className="text-falck-blue hover:text-blue-700"
                        title="Rediger"
                      >
                        <FaEdit />
                      </button>
                      <button
                        onClick={() => handleDelete(laanebil.id)}
                        className="text-red-600 hover:text-red-900"
                        title="Slet"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
        </div></div>
      </div>

      {/* Tilføj/Rediger Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto">
          <div className="bg-white rounded-lg p-6 w-full max-w-md m-4">
            <h2 className="text-xl font-bold mb-4">
              {editingLaanebil ? 'Rediger lånebil' : 'Tilføj ny lånebil'}
            </h2>
            {editingLaanebil ? (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Internt nummer
                  </label>
                  <input
                    type="text"
                    value={formData.internt_nummer}
                    onChange={(e) => setFormData({...formData, internt_nummer: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-falck-blue focus:border-transparent"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Vogn type
                  </label>
                  <input
                    type="text"
                    value={formData.vogn_type}
                    onChange={(e) => setFormData({...formData, vogn_type: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-falck-blue focus:border-transparent"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Status
                  </label>
                  <select
                    value={formData.status}
                    onChange={(e) => setFormData({...formData, status: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-falck-blue focus:border-transparent"
                  >
                    <option value="Tilgængelig">Tilgængelig</option>
                    <option value="Udlånt">Udlånt</option>
                    <option value="Reserve">Reserve</option>
                  </select>
                </div>
                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    onClick={() => {
                      setShowModal(false);
                      setEditingLaanebil(null);
                      setFormData({
                        internt_nummer: '',
                        vogn_type: '',
                        erstatter_bil_id: '',
                        status: 'Tilgængelig'
                      });
                    }}
                    className="px-4 py-2 text-gray-600 bg-gray-200 rounded-md hover:bg-gray-300"
                  >
                    Annuller
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-falck-blue text-white rounded-md hover:bg-blue-700"
                  >
                    Opdater
                  </button>
                </div>
              </form>
            ) : (
              <div className="space-y-4">
                <p className="text-sm text-gray-600">
                  Søg efter eksisterende bil via internt nummer eller nummerplade og gør den til lånebil.
                  Vogn type hentes fra databasen. Type sættes til <strong>Lånebil</strong> og status til <strong>Reserve</strong>.
                </p>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Søg bil</label>
                  <input
                    type="text"
                    value={createQuery}
                    onChange={async (e) => {
                      const q = e.target.value;
                      setCreateQuery(q);
                      setCreateError('');
                      if (q.length < 2) { setCreateResults([]); return; }
                      try {
                        setCreateLoading(true);
                        const res = await axios.get(`/api/search?q=${encodeURIComponent(q)}`);
                        const items = Array.isArray(res.data) ? res.data.filter(r => r.type === 'bil') : [];
                        setCreateResults(items);
                      } catch (err) {
                        setCreateError('Fejl ved søgning');
                        setCreateResults([]);
                      } finally {
                        setCreateLoading(false);
                      }
                    }}
                    placeholder="Internt nr. eller nummerplade"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-falck-blue focus:border-transparent"
                  />
                </div>
                {createLoading && <div className="text-sm text-gray-500">Søger...</div>}
                {createError && <div className="text-sm text-red-600">{createError}</div>}
                <div className="divide-y border border-gray-200 rounded-md max-h-64 overflow-auto">
                  {createResults.map(r => (
                    <div key={`${r.type}-${r.id}`} className="p-3 flex items-center justify-between hover:bg-gray-50">
                      <div>
                        <div className="font-medium">{r.title}</div>
                        <div className="text-xs text-gray-600">{r.subtitle}</div>
                      </div>
                      <button
                        className="px-3 py-1.5 text-sm bg-green-600 text-white rounded hover:bg-green-700"
                        onClick={async () => {
                          try {
                            await axios.post('/api/laanebiler/promote', { car_id: r.id });
                            setShowModal(false);
                            setCreateQuery('');
                            setCreateResults([]);
                            fetchLaanebiler();
                          } catch (e) {
                            setCreateError(e.response?.data?.message || 'Kunne ikke oprette lånebil');
                          }
                        }}
                      >
                        Vælg
                      </button>
                    </div>
                  ))}
                  {!createLoading && createQuery.length >= 2 && createResults.length === 0 && (
                    <div className="p-3 text-sm text-gray-600">Ingen biler fundet</div>
                  )}
                </div>
                <div className="flex justify-end">
                  <button
                    type="button"
                    onClick={() => { setShowModal(false); setEditingLaanebil(null); setCreateQuery(''); setCreateResults([]); }}
                    className="px-4 py-2 text-gray-600 bg-gray-200 rounded-md hover:bg-gray-300"
                  >
                    Luk
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Flyt Modal */}
      {showMoveModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto">
          <div className="bg-white rounded-lg p-6 w-full max-w-md m-4">
            <h2 className="text-xl font-bold mb-4">Flyt Lånebil</h2>
            <form onSubmit={handleMove} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Vælg Lånebil:
                </label>
                <select
                  value={moveData.car_id}
                  onChange={(e) => {
                    const selectedCar = laanebiler.find(car => car.id == e.target.value);
                    setMoveData({...moveData, car_id: e.target.value});
                  }}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-falck-blue focus:border-transparent"
                  required
                >
                  <option value="">Vælg lånebil</option>
                  {laanebiler.map(car => (
                    <option key={car.id} value={car.id} 
                            data-status={car.status}
                            data-station={car.station_navn || ''}
                            data-erstattet={car.erstattet_bil_internt_nummer || 'Ingen'}>
                      {car.internt_nummer} - {car.vogn_type}
                    </option>
                  ))}
                </select>
              </div>
              <div>
              </div>

              {/* Vis lånebil info hvis den er udlånt */}
              {moveData.car_id && (() => {
                const selectedCar = laanebiler.find(car => car.id == moveData.car_id);
                if (selectedCar && selectedCar.status === 'Udlånt') {
                  return (
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <strong>Lånebilen høre til:</strong> {selectedCar.station_navn || 'Ukendt'}<br/>
                      <strong>Erstatter:</strong> {selectedCar.erstattet_bil_internt_nummer || 'Ingen'}
                    </div>
                  );
                }
                return null;
              })()}

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Ny Station:
                </label>
                <select
                  value={moveData.station_id}
                  onChange={(e) => {
                    setMoveData({...moveData, station_id: e.target.value, workshop_car_id: ''});
                    fetchWorkshopCars(e.target.value);
                  }}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-falck-blue focus:border-transparent"
                  required
                >
                  <option value="">Vælg station</option>
                  {stationer.map(station => (
                    <option key={station.id} value={station.id}>
                      {station.navn}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Vælg køretøj til værksted:
                </label>
                <select
                  value={moveData.workshop_car_id}
                  onChange={(e) => setMoveData({...moveData, workshop_car_id: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-falck-blue focus:border-transparent"
                  required
                >
                  <option value="">{moveData.station_id ? 'Vælg køretøj' : 'Ingen station valgt'}</option>
                  {workshopCars.map(car => (
                    <option key={car.id} value={car.id}>
                      {car.internt_nummer} - {car.vogn_type}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Bemærkninger:
                </label>
                <textarea
                  value={moveData.bemaerkninger}
                  onChange={(e) => setMoveData({...moveData, bemaerkninger: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-falck-blue focus:border-transparent"
                  rows="4"
                  placeholder="Evt. noter til flytningen..."
                />
              </div>
              {/* Modtagere nederst */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Send til (valgfrit)</label>
                <div className="flex gap-2">
                  <select
                    value={selectedUserId}
                    onChange={(e) => setSelectedUserId(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-falck-blue focus:border-transparent"
                  >
                    <option value="">Vælg bruger</option>
                    {users.map(u => (
                      <option key={u.id} value={String(u.id)}>
                        {(u.name || u.brugernavn)}{u.email ? ` (${u.email})` : ''}
                      </option>
                    ))}
                  </select>
                  <button
                    type="button"
                    onClick={() => {
                      const idNum = parseInt(selectedUserId);
                      if (!idNum) return;
                      setSelectedRecipients(prev => prev.includes(idNum) ? prev : [...prev, idNum]);
                      setSelectedUserId('');
                    }}
                    className="px-3 py-2 bg-falck-blue text-white rounded-md hover:bg-blue-700"
                  >
                    Tilføj
                  </button>
                </div>
                {users.length === 0 && (
                  <div className="text-sm text-gray-500 mt-1">Ingen brugere fundet</div>
                )}
                {selectedRecipients.length > 0 && (
                  <div className="mt-2 flex flex-wrap gap-2">
                    {selectedRecipients.map(id => {
                      const u = users.find(x => String(x.id) === String(id));
                      const label = u ? (u.name || u.brugernavn || `#${id}`) : `#${id}`;
                      return (
                        <span key={id} className="inline-flex items-center gap-2 px-2 py-1 text-xs rounded-full bg-gray-100 border border-gray-300">
                          {label}
                          <button type="button" className="text-red-600" onClick={() => setSelectedRecipients(prev => prev.filter(x => x !== id))}>×</button>
                        </span>
                      );
                    })}
                  </div>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Ekstra emails (kommasepareret)</label>
                <input
                  type="text"
                  value={manualEmails}
                  onChange={(e) => setManualEmails(e.target.value)}
                  placeholder="fx: a@firma.dk, b@firma.dk"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-falck-blue focus:border-transparent"
                />
              </div>
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  onClick={() => {
                    setShowMoveModal(false);
                    setMoveData({ car_id: '', station_id: '', workshop_car_id: '', bemaerkninger: '' });
                  }}
                  className="px-4 py-2 text-gray-600 bg-gray-200 rounded-md hover:bg-gray-300"
                >
                  Annuller
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-falck-blue text-white rounded-md hover:bg-blue-700"
                >
                  Flyt
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Returner Modal */}
      {showReturnModal && selectedLaanebil && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto">
          <div className="bg-white rounded-lg p-6 w-full max-w-md m-4">
            <h2 className="text-xl font-bold mb-4">
              Returner lånebil - {selectedLaanebil.internt_nummer}
            </h2>
            <p className="text-gray-600 mb-4">
              Er du sikker på, at du vil returnere denne lånebil?
            </p>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => {
                  setShowReturnModal(false);
                  setSelectedLaanebil(null);
                }}
                className="px-4 py-2 text-gray-600 bg-gray-200 rounded-md hover:bg-gray-300"
              >
                Annuller
              </button>
              <button
                onClick={handleReturn}
                className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
              >
                Returner lånebil
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Laanebiler;
